import React from 'react';

export default props => (
    <tbody><tr><td colSpan="999" className="text-center">
        <i className="fa fa-spinner fa-spin" />
    </td></tr></tbody>
)